var exports = {
  "jC": "AddOverridePopout.module__popoutContainer___Y0FWdF",
  "MT": "AddOverridePopout.module__searchContainer___Y0FWdF",
  "XG": "AddOverridePopout.module__scroller___Y0FWdF",
  "uW": "AddOverridePopout.module__section___Y0FWdF",
  "bV": "AddOverridePopout.module__sectionHeader___Y0FWdF",
  "k0": "AddOverridePopout.module__itemButton___Y0FWdF",
  "CB": "AddOverridePopout.module__roleIndicator___Y0FWdF",
  "IR": "AddOverridePopout.module__itemLabel___Y0FWdF",
  "my": "AddOverridePopout.module__avatar___Y0FWdF",
  "p$": "AddOverridePopout.module__emptyState___Y0FWdF",
};

module.exports = exports;
